import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';
import languages, { languagesEpic } from './languages';
import subscriptions from './subscriptions';
import notifications from './notifications';
import authentication from './authentication';
import { INotificationsState } from './notifications';
import user, { IUserState } from './user';
import * as CouponCodes from './couponcodes'
import * as User from './user'
import * as Notifications from './notifications'
import * as Authentication from './authentication'
import * as Navigation from './navigation'
import * as Subscriptions from './subscriptions'
import * as Application from './application'
import { IUserAuthenticationState } from './authentication';

export { Application, Authentication, CouponCodes, User, Notifications, Navigation, Subscriptions }

export interface IRootState {
	user: IUserState;
	authentication: IUserAuthenticationState;
	languages: any;
	subscriptions: any;
	notifications: INotificationsState;
}


export const rootReducer = combineReducers({
	user,
	authentication,
	languages,
	subscriptions,
	notifications,
});

export const rootEpic = combineEpics(languagesEpic);



// WEBPACK FOOTER //
// ./src/store/modules/index.ts